module.exports = __webpack_public_path__ + "img/burger.93f817de.svg";